// new view for showing the current integrations
// Path: client/src/views/account/integrations.js
import React, { Fragment, useContext } from "react";
import {
  Grid,
  Card,
  useAPI,
  Button,
  Image,
  Link,
  Loader,
  AuthContext,
} from "components/lib";
import xeroConnect from "../../assets/xero/connect-white.svg";
import xeroDisconnect from "../../assets/xero/disconnect-white.svg";
import Axios from "axios";

// import Style from "./integrations.module.scss";

// shared logo container + image classes so every integration card's logo
// renders uniformly regardless of the source asset's native aspect ratio
const logoBox = { height: "48px", display: "flex", alignItems: "center", marginBottom: "16px" };
const logoImg = { maxHeight: "100%", width: "auto", maxWidth: "150px", objectFit: "contain" };

export function Integrations(props) {
  const hubspotConnected = useAPI("/api/integration/hubspot/connected");
  const xeroConnected = useAPI("/api/integration/xero/connected");
  const xeroInstall = useAPI("/api/integration/xero/install");
  const hubspotAuthLink = useAPI("/api/integration/hubspot/install");
  const zendeskAuthLink = useAPI("/api/integration/zendesk-sell/install");
  const clioAuthLink = useAPI("/api/integration/clio/install");
  const authContext = useContext(AuthContext);

  //   if (!hubspotConnected.loading) return <Loader />;
  //   if (!xeroConnected.loading) return <Loader />;
  //   if (!xeroInstall.loading) return <Loader />;
  //   if (!hubspotAuthLink.loading) return <Loader />;

  const handleDisconnect = async () => {
    const response = await Axios.get("/api/integration/xero/disconnect");
    console.log(response);
    window.location.reload();
  };

  const xpmInstallAction = async () => {
    const response = await Axios.get("/api/integration/xpm/install");
    console.log(response.data.data.url);
    window.location = response.data.data.url;
  };

  const pipedriveInstallAction = async () => {
    const response = await Axios.get("/api/integration/pipedrive/install");
    console.log(response.data.data.url);
    window.location = response.data.data.url;
  };

  const getXeroButton = () => {
    if (xeroConnected?.data === undefined) {
      return <Loader />;
    }
    if (xeroConnected?.data === true) {
      return (
        <a href="#" onClick={handleDisconnect}>
          <img src={xeroDisconnect} />
        </a>
      );
    }
    if (xeroConnected?.data === false) {
      return (
        <a href={xeroInstall?.data?.url}>
          <Image source={xeroConnect} />
        </a>
      );
    }
  };

  const hubspotInstall = () => {
    window.location = hubspotAuthLink?.data?.url;
  };

  const zendeskSellInstall = () => {
    window.location = zendeskAuthLink?.data?.url;
  };

  const clioInstallAction = async () => {
    const response = await Axios.get("/api/integration/clio/install");
    console.log(response.data.data.url);
    window.location = response.data.data.url;
  };

  return (
    <Fragment>
      <Grid cols="4">
        <Card className="min-h-[180px]">
          <div style={logoBox}>
            <img
              src="/logos/partners/hubspot/logo.svg"
              alt="HubSpot logo"
              style={logoImg}
            />
          </div>
          {hubspotConnected?.data === true ? (
            <Button
              loading={hubspotAuthLink?.loading}
              text="Manage"
              action={() => (window.location = "/account/integrations/hubspot")}
              small
            ></Button>
          ) : (
            <Button
              loading={hubspotAuthLink?.loading}
              text="Manage"
              action={hubspotInstall}
              small
            ></Button>
          )}
        </Card>

        <Card className="min-h-[180px]">
          <div style={logoBox}>
            <img
              src="/logos/partners/xero/logo.svg"
              alt="Xero logo"
              style={logoImg}
            />
          </div>
          <p className="text-xs leading-6">
            Status: {xeroConnected.data ? "Connected" : "Disconnected"}
          </p>
          {!xeroConnected.loading && getXeroButton()}
        </Card>

        <Card className="min-h-[180px]">
          <div style={logoBox}>
            <img
              src="/logos/partners/xero-practice-manager/logo.svg"
              alt="Xero Practice Manager logo"
              style={logoImg}
            />
          </div>
          <p className="text-xs leading-6">
            Xero Practice Manager:{" "}
            {xeroConnected.data ? "Connected" : "Disconnected"}
          </p>
          <Button text="Install" action={xpmInstallAction} small></Button>
          <p className="text-xs leading-6">
            <Link
              url="/account/integrations/xpm"
              text="Manage"
              small
              btn
            ></Link>
          </p>
        </Card>

        <Card className="min-h-[180px]">
          <div style={logoBox}>
            <img
              src="/logos/partners/pipedrive/logo.svg"
              alt="Pipedrive logo"
              style={logoImg}
            />
          </div>
          <p className="text-s leading-6">Pipedrive</p>
          <Button text="Install" action={pipedriveInstallAction} small></Button>
        </Card>

        <Card className="min-h-[180px]">
          <div style={logoBox}>
            <img
              src="/logos/partners/fyi/mark.png"
              alt="FYI Docs logo"
              style={logoImg}
            />
          </div>
          <p className="text-s leading-6">FYI Docs</p>
          <Button
            text="Install"
            action={() => (window.location = "/account/integrations/fyi")}
            small
          ></Button>
        </Card>

        <Card className="min-h-[180px]">
          <div style={logoBox}>
            <img
              src="/logos/partners/karbon/logo.png"
              alt="Karbon logo"
              style={logoImg}
            />
          </div>
          <p className="text-s leading-6">Karbon (beta)</p>
          <Button
            text="Install"
            action={() => (window.location = "/account/integrations/karbon")}
            small
          ></Button>
        </Card>

        <Card className="min-h-[180px]">
          <div style={logoBox}>
            <img
              src="/logos/partners/zendesk-sell/logo.svg"
              alt="Zendesk Sell logo"
              style={logoImg}
            />
          </div>
          <p className="text-s leading-6">Zendesk Sell</p>
          <Button text="Install" action={() => zendeskSellInstall()} small></Button>
        </Card>

        <Card className="min-h-[180px]">
          <div style={logoBox}>
            <img
              src="/logos/partners/clio/mark.png"
              alt="Clio logo"
              style={logoImg}
            />
          </div>
          <p className="text-s leading-6">Clio</p>
          <Button text="Install" action={clioInstallAction} small></Button>
          <p className="text-xs leading-6">
            <Link
              url="/account/integrations/clio"
              text="Manage"
              small
              btn
            ></Link>
          </p>
        </Card>

        <Card className="min-h-[180px]">
          <div style={logoBox}>
            <img
              src="/logos/partners/monday/logo.svg"
              alt="Monday CRM logo"
              style={logoImg}
            />
          </div>
          <p className="text-s leading-6">Monday CRM</p>
          <Button
            text="Manage"
            action={() => (window.location = "/account/integrations/monday")}
            small
          ></Button>
        </Card>
      </Grid>
    </Fragment>
  );
}
